<div class="card loader-wrapper" *ngIf="isLoading">
  <div class="card-body loader-area">
    <div class="loader d-flex align-items-center justify-content-center">
      <i class="fa fa-spinner app-loader"></i>
    </div>
  </div>
</div>
